import classNames from 'classnames';

export function Pill({ color, filled = false, className, children }) {
  return (
    <div
      className={classNames(
        'text-body-2 flex flex-wrap items-center rounded-full border border-malibu-500 px-[8px]',
        className,
      )}
      style={{ borderColor: color ? color : undefined, background: filled ? color : undefined }}
    >
      {children}
    </div>
  );
}
